module.exports = kolibriCoreAppGlobal.client;